module.exports = __webpack_public_path__ + "img/icon-faq-04.c0787cf7.png";